export default __webpack_public_path__ + "static/media/sky.6f187492.jpg";